import { FC } from 'react';
import { LayoutCarousel } from '@silverfort/sf-components';

import { TokenDistributionSummary } from '../../types';
import { useTokensDistributionData } from './hooks/useTokensDistributionData';
import { AuthenticatorType } from '../../../../containers/LogsDrawer/types';
import usePaginatedDonutChart from '../../hooks/usePaginatedDonutChart';

interface TokensDistributionChartProps {
    tokenDistributionSummary?: TokenDistributionSummary;
    isLoading: boolean;
    className?: string;
    onClick: (token: AuthenticatorType) => void;
    innerCircleEmptyStateClassName?: string;
}

const TokensDistributionChart: FC<TokensDistributionChartProps> = ({
    tokenDistributionSummary,
    isLoading,
    className,
    onClick,
    innerCircleEmptyStateClassName = ''
}) => {
    const chartData = useTokensDistributionData(onClick, tokenDistributionSummary);
    const pages = usePaginatedDonutChart({ chartData, isLoading, innerCircleEmptyStateClassName });

    return (
        <LayoutCarousel
            title="Tokens distribution"
            className={className}
            contentClassName="flex flex-1 flex-col justify-center px-6 flex-shrink-0 h-full min-h-[150px]"
            pages={pages}
        />
    );
};

export default TokensDistributionChart;
